module.exports = __webpack_public_path__ + "static/media/handbike2.8d02b267.jpg";